import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import DFFCloneService from '../../../Services/DFFCloneService';
import Button from '../../Common/Button';
import ConfigService from "../../../Services/api/Config";
import Icon from "../../Common/Icon";
import {ReactComponent as InfoIcon} from "../../../../img/icon-info.svg";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalRemoveSection extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    DFFCloneService.removeSection(this.props.api, this.props.configuration);
    this.props.onClose(event);
  };

  render() {
    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Remove Section'
        className='Modal_Content'
        overlayClassName='Modal_Overlay'
      >
        <div className='Modal_Content_Container Center'>
          <h2>REMOVE SECTION FORM</h2>
          <div className='Warning_Container' style={ { color: ConfigService.getColor('warningColor') } }>
            <Icon className='Icon-Warning' width='16' height='16' color='warningColor'>
              <InfoIcon alt='icon-info'/>
            </Icon>
            Are you sure you want to remove this section?
          </div>
          <div className='Modal_Content_Actions Center'>
            <Button className='Button_Delete Inline'
              onClick={ this.onPressSave }
            >
              Yes
            </Button>
            <Button className='Button_Cancel Inline'
              onClick={ this.onPressClose }
            >
              Cancel
            </Button>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalRemoveSection.propTypes = {
  configuration: PropTypes.object.isRequired,
  api: LfaContextAPIShape,
  onClose: PropTypes.func.isRequired,
};

export default ModalRemoveSection;
